import { AfterViewInit, Component, inject, signal } from "@angular/core";
import { NgClass } from "@angular/common";
import { NavBarService } from "@app/layouts/nav-bar/nav-bar.service";
import { TitleNavBarComponent } from "@app/layouts/nav-bar/title-nav-bar/title-nav-bar.component";
import { ItemButtonNavBarComponent } from "@app/layouts/nav-bar/item-button-nav-bar/item-button-nav-bar.component";
import { ItemLinkNavBarComponent } from "@app/layouts/nav-bar/item-link-nav-bar/item-link-nav-bar.component";
import { isArray } from "lodash-es";
import { PermissionsService } from "@app/core/services";

@Component({
  selector: "app-nav-bar",
  standalone: true,
  imports: [
    NgClass,
    TitleNavBarComponent,
    ItemButtonNavBarComponent,
    ItemLinkNavBarComponent,
  ],
  templateUrl: "./nav-bar.component.html",
  styleUrl: "./nav-bar.component.scss",
})
export class NavBarComponent implements AfterViewInit {
  protected readonly disableAnimation = signal<boolean>(false);
  private readonly mainLayoutService = inject(NavBarService);
  protected readonly menuItems = this.mainLayoutService.getSignalMenuItems();
  protected readonly isMinimized =
    this.mainLayoutService.getSignalIsMinimized();
  private readonly permissionService = inject(PermissionsService);

  ngAfterViewInit(): void {
    // Нужно для отключения анимации из открытого в закрытое состояния nav-ber, при первоначальной загрузке (когда в LS - состояние - закрыто)
    if (this.isMinimized()) {
      this.disableAnimation.set(true);
      setTimeout(() => {
        this.disableAnimation.set(false);
      }, 0);
    }
  }

  protected isVisible(visible: string | string[] | boolean): boolean {
    return this.hasPermission(visible);
  }

  private hasPermission(permission: string | string[] | boolean): boolean {
    if (typeof permission === "boolean") return permission;
    if (isArray(permission))
      return permission.some((p) => {
        return this.permissionService.has(p);
      });
    return this.permissionService.hasNav(permission);
  }
}
